import { z } from 'zod'

export const UploadedDocumentKeySchema = z
  .string({
    invalid_type_error: `Chargement d'un fichier obligatoire`,
    required_error: `Chargement d'un fichier obligatoire`
  })
  .min(1, `Chargement d'un fichier obligatoire`)
